<template>
  <Top>
    <div class="edit">
      <div class="content">
        <div>
          <van-field v-model="groupInfo.name" maxlength="15" autofocus ref="input" show-word-limit label="名称"
            placeholder="请输入程序名" />
        </div>

        <!-- 启动方式 -->
        <div>
          <!-- 选择启动方式 -->
          <van-cell is-link title="选择启动方式" @click="method.show = true" :value="method.value" />
          <van-action-sheet v-model="method.show" :actions="method.range"
            @select="onSelectChange($event, 'method', 'value')" :round="false" :close-on-click-action="true" />
        </div>

        <!-- 时间 -->
        <div v-if="method.type === 2">
          <!-- type = 定时  触发时间 -->
          <van-cell is-link title="触发时间" @click="time.show = true" :value="computedTime" />
          <van-popup v-model="time.show" position="bottom" :style="{ width: '100%', height: '6.8rem' }">
            <van-datetime-picker v-model="time.value" type="datetime" title="触发时间" :formatter="formatter"
              customFormat="yyyy-MM-dd HH:mm:ss" dateFormat="custom" :min-date="minDate" @confirm="handleChangeTme"
              @cancel="time.show = false" />
          </van-popup>

          <van-cell title="触发周期" @click.stop="time.zqShow = true" :value="time.zqValue" class="zq">
            <template slot="default">
              <van-radio-group v-model="time.zqValue" direction="horizontal" class="action_range">
                <van-radio v-for="item in radioList" :key="item.value" :name="item.value"
                  @click="onSelectChange(item.value, 'time', 'zqValue')">
                  {{ item.name }}
                </van-radio>
              </van-radio-group>
            </template>
          </van-cell>
        </div>

        <!-- 传感器 -->
        <div v-else-if="method.type === 3">
          <!-- type = 选择关联传感器 -->
          <van-cell is-link title="关联传感器" @click="showModal = true" :value="cgq.value" />

          <!-- type = 传感器 触发条件 大于 等于 小于 -->
          <van-cell title="触发条件" class="cgq">
            <template slot="default">
              <van-radio-group v-model="cgq.confitionValue" direction="horizontal"
                @change="onSelectChange($event, 'cgq', 'confitionValue')">
                <van-radio name="1">大于</van-radio>
                <van-radio name="2">等于</van-radio>
                <van-radio name="3">小于</van-radio>
              </van-radio-group>
            </template>
          </van-cell>

          <van-field v-model="cgq.threshold" maxlength="15" autofocus ref="threshold_inp" label="传感器阀值"
            placeholder="请设置传感器阀值" class="threshold_inp" />
        </div>

        <!-- 分组列表 -->

        <div class="fm-list fs28">
          <div class="title">分组列表</div>
          <div class="fm-item">
            <van-checkbox-group v-model="checkGroupList">
              <van-checkbox class="check-item" v-for="item in groupList" :key="item.id" :name="item.id">
                <!-- @click="handleChoose(index)" -->
                <!-- <span class="circular" :class="item.num && 'active'">
                  {{ item.num || '' }}
                </span> -->
                {{ item.name }}
              </van-checkbox>
            </van-checkbox-group>
          </div>
        </div>
      </div>

      <div class="footer">
        <span class="cancel" @click="handleCancel">取消</span>
        <span class="add" @click="handleComfirm">确定</span>
      </div>
      <!-- 星期 modal -->
      <DateListModal :show="showDateModal" :data="weekModalData" @confirm="dateModalConfirm" @cancel="dateModalCancel" />
      <!-- 传感器modal -->
      <CgqListModal :show="showModal" @confirm="modalConfirm" @cancel="showModal = false" />
    </div>
  </Top>
</template>

<script>
import Top from './../../top.vue'
import { Dialog } from 'vant'
import CgqListModal from './cgqModal'
import DateListModal from './dateModal'
let choose_index = 1

export default {
  components: {
    CgqListModal,
    DateListModal,
    Top,
  },

  data () {
    function timeRange (num) {
      const _arr = []
      for (let i = 0; i < num; i++) {
        _arr.push(i.toString().padStart(2, '0'))
      }
      return _arr
    }

    return {
      groupInfo: {},
      type: '',
      groupList: [],
      pickerData: [0, 0, 0],
      // fmListIndex: null, // 选择那个阀门的时长
      // 启动类型
      method: {
        show: false,
        value: '',
        range: [
          { name: '手动', type: 1 },
          { name: '定时', type: 2 },
          // { name: "关联传感器", type: 3 }
        ],
        type: null,
      },
      // 定时
      time: {
        show: false, // 选择定时时长 弹窗
        range: [],
        value: null,
        zqShow: false,
        zqValue: '1',
        zqRange: [
          {
            name: '执行一次',
          },
          {
            name: '每日执行',
          },
          {
            name: '每周执行',
          },
        ],
      },
      // 关联传感器
      cgq: {
        show: false,
        range: [],
        // 弹窗
        showConfition: false,
        // 传感器触发条件
        confitionValue: ['1'],
        threshold: '',
      },
      ishow: false,
      showModal: false,
      showDateModal: false,
      radioList: [
        {
          name: '一次',
          value: '1',
        },
        {
          name: '每日',
          value: '2',
        },
        {
          name: '每周',
          value: '3',
        },
      ],
      minDate: new Date(), // 最小时间
      weekModalData: [], // 星期modal
      weekStrData: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      checkGroupList: [],
      // showActionTime: false,
      // actionTime: "" // 执行时长
    }
  },

  computed: {
    computedTime () {
      if (this.time.value) return this.$setime(this.time.value, 3)
      return ''
    },
  },

  watch: {
    groupList: {
      handler: (v) => {
        console.log('列表: ', v)
      },
      deep: true,
    },
  },

  async mounted () {
    const { type, data } = this.$route.query
    this.type = type

    // 获取分组列表
    this.groupList = await this.getGroupList()

    if (type === 'add') {
      this.groupInfo = {
        name: '',
      }
    } else {
      // 编辑
      this.groupInfo = JSON.parse(data)
      // 解析分组序号
      const { groups } = this.groupInfo
      let num = 1

      this.groupList.map((item) => {
        const tar = groups.find((o) => o.id === item.id)

        if (tar) {
          item.num = num++

          this.checkGroupList.push(tar.id)
        }
      })

      console.log('this.checkGroupList:', this.groupList, groups)

      // 启动方式
      const type = Number(this.groupInfo.triggers.type)
      const tar = this.method.range.find((o) => o.type === Number(type))
      this.method.value = tar.name
      this.method.type = tar.type

      // 定时的 展示出发时间 触发周期 解析 cron 表达式
      if (type === 2) {
        const cron = this.groupInfo.triggers.cronExpression

        this.parseCron(cron)
      }
    }
  },

  methods: {
    // 解析 cron 表达式
    // 解析出 执行周期  执行时间  如果是 每周几执行 则需要解析 周几
    parseCron (cron) {
      const cronArr = cron.split(' ').filter((o) => o)
      cronArr.shift()
      // 解析出每周的条件
      const last = cronArr[cronArr.length - 1]
      if (last !== '*') {
        if (last.indexOf(',') > -1) {
          const weekIdList = last
            .split(',')
            .filter((o) => o)
            .map((item, index) => {
              return {
                id: this.weekStrData.findIndex((o) => o === item) + 1,
              }
            })

          this.time.zqValue = '3'
          // 保存每周的数据 通过 id 数字来匹配  1:星期一
          this.dateModalConfirm(weekIdList)
        }
      } else {
        const newCronArr = cronArr.filter((o) => o !== '*')

        if (newCronArr.length === 2) {
          // 只有 时 分 其他都是 * 数组长度只有 2
          this.time.zqValue = '2'
        } else {
          this.time.zqValue = '1'
        }
      }

      // 解析时间  秒 分 时 日  月   默认年为今年
      const timeArr = [
        {
          label: 'm',
          value: '00',
        },
        {
          label: 'h',
          value: '00',
        },
        {
          label: 'd',
          value: new Date().getDate(),
        },
        {
          label: 'mon',
          value: new Date().getMonth() + 1,
        },
      ]

      // 把最后一个星期删掉
      cronArr.pop()
      cronArr.map((item, index) => {
        if (item !== '*') {
          if (timeArr[index]) {
            timeArr[index].value = item.padStart(2, '0')
          }
        }
      })
      const year = new Date().getFullYear()
      timeArr.reverse()

      const date = `${year}/${timeArr[0].value}/${timeArr[1].value} ${timeArr[2].value}:${timeArr[3].value}:00`

      console.log('date:', timeArr, date)

      this.time.value = new Date(date)
    },

    formatter (type, val) {
      if (type === 'hour') {
        return val + '时'
      }
      if (type === 'month') {
        return val + '月'
      }
      if (type === 'day') {
        return val + '日'
      }
      if (type === 'minute') {
        return val + '分'
      }
      return val
    },

    // 触发时间
    handleChangeTme (v) {
      console.log('v:', v)
      this.time.show = false
      this.time.value = v
    },

    // 公共方法，修改不同属性
    onSelectChange (v, key1, key2) {
      console.log(v, key1, key2)
      // 针对时间的 周期
      if (typeof v === 'string' && v === '3' && key1 === 'time')
        this.showDateModal = true
      if (v.name) this[key1][key2] = v.name
      if (v.type) this.method.type = v.type
      // 针对
      if (Array.isArray(v)) this[key1][key2] = v
    },

    // 获取分组列表
    async getGroupList () {
      return await this.$api
        .getGroup({
          gatewayNo: localStorage.getItem('no'),
        })
        .then((res) => {
          if (res.errcode === 0) {
            if (!this.$isblank(res.data)) {
              const data = res.data
              return data.map((item) => {
                return {
                  ...item,
                  num: null,
                  timeLong: '00:00:00',
                }
              })
            } else {
              return []
            }
          } else {
            this.$toast(res.errmsg)
            return []
          }
        })
    },

    // 选择分组
    handleChoose (index) {
      console.log('index:', index, this.groupList[index])

      if (this.groupList[index].num) {
        this.groupList.map((item) => {
          if (item.num && item.num > this.groupList[index].num) {
            --item.num
          }
        })
        this.groupList[index].num = null
        --choose_index
      } else {
        this.$set(this.groupList[index], 'num', choose_index)
        choose_index++
      }
    },

    // 查看错误日志页面
    handleErr () {
      this.$router.push({
        path: '/programErr',
      })
    },

    // 取消展示 日期modal
    dateModalCancel () {
      this.showDateModal = false
      if (this.radioList[2].name === '每周') {
        this.time.zqValue = '1'
      }
    },

    // 星期modal 确认
    dateModalConfirm (data) {
      console.log('星期：', data)
      if (data && data.length) {
        let name = '每周'
        data.map((item) => {
          const txt = this.$noToChinese(item.id)
          name += `${txt === '七' ? '日' : txt}、`
        })

        this.radioList[2].name = name

        this.weekModalData = data
      } else {
        this.time.zqValue = '1'
        this.radioList[2].name = '每周'
      }
    },

    // 传感器modal 目前只支持一个传感器
    modalConfirm (data) {
      console.log('传感器:', data)
      this.showModal = false
      this.cgq.range = data
      if (data && data.length) {
        let name = ''
        data.map((item) => {
          name = `${item.aliasName}`
        })
        if (name.length > 15) {
          this.cgq.value = name.slice(0, 15) + '...'
        } else {
          this.cgq.value = name
        }
      } else {
        this.cgq.value = null
      }
    },

    // 取消
    handleCancel () {
      this.$router.back()
    },

    // 确定 提交
    async handleComfirm () {
      if (!this.groupInfo.name) return this.$toast.fail('分组名称不能为空')
      if (!this.method.value) return this.$toast.fail('请选择启动方式')
      // 手动 1
      // 定时 2  触发时间
      // 关联传感器 3 关联传感器列表 触发条件
      if (this.method.type === 2) {
        if (!this.time.value) return this.$toast.fail('请选择触发时间')
      } else if (this.method.type === 3) {
        if (!this.cgq.range.length)
          return this.$toast.fail('请选择关联的传感器')
        if (!this.cgq.confitionValue) return this.$toast.fail('请选择触发条件')
      }

      // 选择分组
      // const checkList = this.groupList.filter((o) => o.num)
      // if (!checkList || !checkList.length) return this.$toast.fail('请选择分组')
      if (!this.checkGroupList || !this.checkGroupList.length)
        return this.$toast.fail('请选择分组')

      // 提交
      const params = {
        name: this.groupInfo.name,
        gatewayNo: localStorage.getItem('no'),
        groupIds: this.checkGroupList,
        // groupIds: this.groupList.filter((o) => o.num).map((item) => item.id),
        triggers: {
          type: this.method.type.toString(),
        },
      }

      // 定时的时候  需要对触发时间做cron表达式转换
      if (this.method.type === 2) {
        const date = new Date(this.time.value)
        let year = date.getFullYear(),
          mon = date.getMonth() + 1,
          day = date.getDate(),
          hour = date.getHours(),
          min = date.getMinutes()

        // 秒（Seconds）	        0~59的整数	                        , - * / 四个字符
        // 分（Minutes）	        0~59的整数	                        , - * / 四个字符
        // 小时（Hours）	        0~23的整数	                        , - * / 四个字符
        // 日期（DayofMonth）	    1~31的整数（但是你需要考虑你月的天数）	 ,- * ? / L W C     八个字符
        // 月份（Month）	        1~12的整数或者 JAN-DEC	              , - * /    四个字符
        // 星期（DayofWeek）	    1~7的整数或者 SUN-SAT （1=SUN）	      , - * ? / L C #     八个字符
        // 年(可选，留空)（Year）	 1970~2099	                          , - * /    四个字符

        let cron = ''
        // 执行一次  直接确定好年月日时分秒
        if (this.time.zqValue === '1') {
          cron = `0 ${min} ${hour} ${day} ${mon} *`
        } else if (this.time.zqValue === '2') {
          // 每日执行
          cron = `0 ${min} ${hour} * * *`
        } else {
          // 每周执行 每周几 执行
          const week = this.weekModalData.map((item) => {
            return this.weekStrData[item.id - 1]
          })

          cron = `0 ${min} ${hour} * * ${week.join(',')}`
        }

        params.triggers.cronExpression = cron
      }

      console.log('params:', params)

      // 新增
      if (this.type === 'add') {
        this.addProgram(params)
      } else {
        this.editProgram(params)
      }
    },

    // 新增
    async addProgram (params) {
      this.$toast.loading({
        message: '请求发送中...',
        duration: 0,
        mask: true,
      })
      await this.$api
        .lgAddProgram(params)
        .then((res) => {
          if (res.errcode === 0) {
            this.$toast.success('添加成功')
            setTimeout(() => {
              this.$router.back()
            }, 1500)
          } else {
            this.$toast.fail(res.errmsg || '添加失败')
          }
        })
        .catch((err) => {
          console.log('err:', err)

          if (err.message.indexOf('timeout') > -1) {
            this.$toast.fail('请求超时')
          } else {
            this.$toast.fail(err.message)
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.$toast.clear()
          }, 1000)
        })
    },

    // 编辑
    async editProgram (params) {
      delete params.groupIds

      const groups = []

      this.groupInfo.groups.map((item) => {
        let tar = null
        this.groupList.find((o) => {
          if (o.id === item.id && o.num) {
            tar = item
          }
        })

        if (tar) {
          const { name, second, status, valveList } = tar
          const obj = {
            id: this.groupInfo.id,
            name,
            second,
            status,
            eqValveList: valveList,
          }

          groups.push(obj)
        }
      })
      params.groups = groups
      params.id = this.groupInfo.id

      console.log('params2222222:', params)

      Dialog.confirm({
        title: '编辑',
        message: '确认修改吗？',
        beforeClose: async (action, done) => {
          if (action === 'confirm') {
            await this.$api
              .lgModifyProgram(params)
              .then((res) => {
                if (res.errcode === 0) {
                  this.$toast.success('修改成功')
                  setTimeout(() => {
                    this.$router.back()
                  }, 1500)
                } else {
                  this.$toast.fail(res.errmsg || '修改失败')
                }
              })
              .catch((err) => {
                if (err.message.indexOf('timeout') > -1) {
                  this.$toast.fail('请求超时')
                } else {
                  this.$toast.fail(err.message)
                }
              })
              .finally(() => {
                done()
                setTimeout(() => {
                  this.$toast.clear()
                }, 1000)
              })
          } else {
            done()
          }
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.zq,
.cgq {
  /deep/.van-cell__value {
    flex: auto !important;
    max-width: 60%;

    .van-radio-group,
    .van-checkbox-group {
      justify-content: flex-end;
    }
  }
}

.edit {
  height: 100%;
  background: #ffffff;
  border-radius: 12px;
}

.footer {
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 30px);
  height: 72px;
  background: #ffffff;
  box-shadow: 0px 5px 5px rgba(208, 199, 255, 0.06);
  margin-left: -15px;
  margin-right: -15px;
  padding: 0 15px;

  span {
    height: 42px;
    line-height: 42px;
    border: 1px solid #3865ff;
    border-radius: 5px;
    text-align: center;
    font-size: 16px;
  }

  .cancel {
    width: 120px;
    margin-right: 15px;

    color: #3865ff;
  }

  .add {
    flex: 1;
    background: #3865ff;
    color: #ffffff;
    border-radius: 5px;
  }
}

.fm-list {
  padding: 0 0.3rem 20px;

  .title {
    height: 21px;
    font-size: 15px;
    font-weight: bold;
    color: #14284a;
    margin-bottom: 10px;
  }

  .check-item {
    display: flex;
    margin-bottom: 0.2rem;

    &::after {
      margin-bottom: 0;
    }
  }
}

.circular {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #999999;
  display: inline-block;
  vertical-align: bottom;
  margin-right: 5px;
  text-align: center;
}

.circular2 {
  @extend .circular;
  border: none !important;
}

.active {
  background: #1989fa;
  color: #ffffff;
}

.time-long {
  border: 1px solid rgba(0, 0, 255, 0.28);
  border-radius: 2px;
  padding: 0 5px;
  background: rgba(0, 0, 255, 0.18);
}

.has-err {
  color: red;
}

.action_range {
  display: flex;
}

.threshold_inp {
  text-align: right;
}

.van-cell {
  padding: 17px 15px !important;

  /deep/ .van-cell__title {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    color: #14284a;
  }

  /deep/ .van-cell__value {
    display: flex;
    width: 100%;
    justify-content: flex-end;
  }

  /deep/ .van-field__body {
    width: 100%;

    input {
      width: 100%;
    }
  }
}
</style>
